<template>
  <div>
    <b-dropdown
      variant="transparent"
      toggle-class="text-decoration-none"
      button-class="p-0"
      no-caret
      right
    >
      <template v-slot:button-content>
        <i class="fa btn-top-navbar fa-tools"></i>
        <span class="badge badge-info ml-1">novo</span>
      </template>
      <template>
        <div>
          <b-dropdown-item
            href="https://api.whatsapp.com/send?phone=+5533984072771&text=Ol%C3%A1%20,%20Gostariamos%20de%20solicitar%20por%20suporte%20técnico!"
            target="_blank"
          >
            <i class="fab fa-whatsapp mr-2 text-success"></i>Suporte
          </b-dropdown-item>
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item
            href="https://www.youtube.com/channel/UCSoCfqcgHLtFYAv7dXAq0nw/videos"
            target="_blank"
          >
            <i class="fab fa-youtube mr-1 text-danger"></i>Treinamento
          </b-dropdown-item>
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item @click="$router.push('/assinar')">
            <i class="fas fa-credit-card mr-1"></i> Assinatura
          </b-dropdown-item>
        </div>
      </template>
    </b-dropdown>
  </div>
</template>
<script>
export default {};
</script>